import React from 'react'
import SelectComponent from '@Components/Selectors/Select'
import { observer } from 'mobx-react'
import PayeeFilter from '@Components/PayeeFilter'
import { RoyaltiesStatementsContext } from '@Scenes/RightsholderScene/RightsholderRoyaltiesStatements/hooks/useRoyaltiesStatements'
import { useOutletContext } from 'react-router'

const RoyaltiesStatementsFilter = () => {
    const {
        statementsStore,
        selectedPayee,
        selectedDsp,
        setPayeeAndLoadStatements,
        useRoyaltiesForPeriod,
        setDsp,
        payeeOptionsForSelect,
        dspOptions,
    } = useOutletContext<RoyaltiesStatementsContext>()

    return (
        <div className="filter-block royalties-statements-filter-block">
            <div className="filter-item-wrapper">
                <div className="filter-item">
                    <p className="small bold">
                        <label htmlFor="distribution-periods">Distribution Period:</label>
                    </p>
                    <SelectComponent
                        options={statementsStore.royaltiesUsagePeriodOptions}
                        name="distribution-periods"
                        selectedValue={statementsStore.selectedUsagePeriod}
                        defaultValue={statementsStore.royaltiesUsagePeriodOptions[0]}
                        onValueChange={useRoyaltiesForPeriod}
                    />
                </div>
            </div>
            <div className="filters-row">
                <div className="filter-item-wrapper">
                    <div className="filter-item">
                        <PayeeFilter
                            payeeOptions={payeeOptionsForSelect}
                            setPayee={setPayeeAndLoadStatements}
                            selectedPayee={selectedPayee}
                            label="Royalty Payee:"
                        />
                    </div>
                </div>
                <div className="filter-item-wrapper">
                    <div className="filter-item">
                        <p className="small bold">
                            <label htmlFor="dsp-options">DSP:</label>
                        </p>
                        <SelectComponent
                            options={dspOptions}
                            name="dsp-options"
                            selectedValue={selectedDsp}
                            isDisabled={!selectedPayee?.value}
                            defaultValue={dspOptions[0]}
                            onValueChange={setDsp}
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default observer(RoyaltiesStatementsFilter)
